module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_1.a0c92efa.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_1.json
// module id = 2355
// module chunks = 0